// extracted by mini-css-extract-plugin
export var arrows = "_27-5";
export var decrementer = "_27-9";
export var disabled = "_27-3";
export var error = "_27-1";
export var hiddenText = "_27-a";
export var incrementer = "_27-8";
export var input = "_27-7";
export var inputWrapper = "_27-0";
export var leadingIcon = "_27-b";
export var readonly = "_27-2";
export var regular = "_27-6";
export var small = "_27-4";